module.exports = __webpack_public_path__ + "img/img3.f5502b2e.png";